import gsap from 'gsap';

function init( node ) {
	if ( ! ( node instanceof HTMLElement ) ) {
		return;
	}

	// Disable scroll-behavior: smooth set in reset.scss which causes issues with ScrollTrigger
	document.documentElement.style.scrollBehavior = 'auto';

	const videoSliderItems = node.querySelector( '.video-scroll-slider__layout' );

	if ( ! videoSliderItems ) {
		console.warn( 'Could not find target element.' );
		return;
	}

	// clone the items
	const originalItems = Array.from( videoSliderItems.children );

	// create duplicates of items and append them
	originalItems.forEach( ( item ) => {
		const clone = item.cloneNode( true );
		clone.classList.add( 'is-cloned-item' );
		videoSliderItems.appendChild( clone );
	} );

	const getScrollAmount = () => {
		let sliderWidth = videoSliderItems.scrollWidth;
		let containerWidth = node.offsetWidth;
		return -( sliderWidth - containerWidth );
	};

	const tween = gsap.to( videoSliderItems, {
		x: getScrollAmount,
		ease: 'power1.out',
	} );

	ScrollTrigger.create( {
		trigger: node,
		start: 'top bottom',
		end: 'bottom top',
		animation: tween,
		scrub: 1,
		invalidateOnRefresh: true,
		markers: false,
	} );
}

document.querySelectorAll( '.video-scroll-slider' ).forEach( init );
